// utils/exportToExcel.ts
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const exportToExcel = async (
  sheets: { sheetName: string; data: any[] }[],
  fileName = 'Timesheet Report'
) => {
  const workbook = new ExcelJS.Workbook();

  sheets.forEach(({ sheetName, data }) => {
    const worksheet = workbook.addWorksheet(sheetName);

    if (data.length > 0) {
      const headers = Object.keys(
        data.reduce((a, b) =>
          Object.keys(a).length > Object.keys(b).length ? a : b
        )
      );
      worksheet.addRow(headers);

      data.forEach((row) => {
        const rowData = headers.map((h) =>
          row[h] !== undefined ? row[h] : null
        );
        worksheet.addRow(rowData);
      });
    }

    worksheet.columns = [
      { width: 15 },
      { width: 25 },
      { width: 15 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
    ];
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  });
  saveAs(blob, `${fileName}.xlsx`);
};
